type SpacerProps = { width: number };

const Spacer = ({ width }: SpacerProps) => <div style={{ width, display: 'inline-block' }} />;

export default Spacer;
